import { httpClient } from '../base/httpClient';

export interface DashboardStats {
  clients: {
    total: number;
    active: number;
    inactive: number;
  };
  accounts: {
    total: number;
    active: number;
    inactive: number;
    with_employees: number;
    unassigned: number;
  };
  users: {
    total: number;
    active: number;
    inactive: number;
    by_role: Record<string, number>;
  };
  blotters: {
    total: number;
    this_month: number;
    by_status: Record<string, number>;
  };
  transactions: {
    total: number;
    this_month: number;
    completed: number;
    pending: number;
  };
  commissions: {
    total_commission: number;
    total_payout: number;
    net_commission: number;
    this_month: {
      total_commission: number;
      total_payout: number;
    };
    user_commissions: {
      total: number;
      paid: number;
      unpaid: number;
    };
  };
  recent_activity: {
    latest_blotter: any | null;
    latest_transaction: any | null;
  };
}

export interface TopPerformer {
  user_id: number;
  user_name: string;
  user_email: string | null;
  total_earned: number;
}

export interface TopAccount {
  account_id: number;
  account_name: string;
  client_name: string;
  total_commission: number;
}

export interface CommissionTrend {
  month: string;
  total_commission: number;
  payout_commission: number;
  net_commission: number;
  blotter_count: number;
}

class DashboardService {
  async getOverview(): Promise<DashboardStats> {
    const response = await httpClient.getClient().get('/dashboard/overview');
    return response.data.data;
  }

  async getTopPerformers(): Promise<TopPerformer[]> {
    const response = await httpClient.getClient().get('/dashboard/top-performers');
    return response.data.data;
  }

  async getTopAccounts(): Promise<TopAccount[]> {
    const response = await httpClient.getClient().get('/dashboard/top-accounts');
    return response.data.data;
  }

  async getCommissionTrends(): Promise<CommissionTrend[]> {
    const response = await httpClient.getClient().get('/dashboard/commission-trends');
    return response.data.data;
  }
}

export const dashboardService = new DashboardService();
